import { observer } from 'mobx-react-lite'
import React from 'react'
import { TbVocabulary } from 'react-icons/tb'

import { IPageConfig } from '@/Core/Contracts/Loaders/IPageConfig'
import { AccessDenied } from '@/Ship/Components/AccessDenied'

import { SettingsList } from '../Components/SettingsList'
import { useListResourceKeys } from '../Hooks'
import { CheckDictionaryPageAccessTask } from '../Tasks/CheckDictionaryPageAccessTask'

/**
 * Сторінка «Довідники» (`SPEC-007` §7.1–§7.3) на `/settings`.
 *
 * Доступ — лише адміністратору, як і пункт меню (`GATED_MENU_ITEMS`). Перевірка
 * — у самій сторінці, а не в `pageConfig.accessFn` маршруту: маршрутний
 * `accessFn` ядро ставить замість перевірки каркаса, і відмова малювалася б без
 * меню й шапки, а неавторизований бачив би її замість форми входу.
 */
const IndexPage: React.FC = observer(() => {
    // Динамічно отримуємо список довідників з ресурсів Setting.List*
    const menuItemsBase = useListResourceKeys()

    if (!CheckDictionaryPageAccessTask()) return <AccessDenied />

    return <SettingsList menuItemsBase={menuItemsBase} />
})

export const pageConfig: IPageConfig = {
    route: '/settings',
    title: 'Довідники',
    icon: <TbVocabulary />,
}

export default IndexPage
